import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ErrorFragmentDoc } from '../../fragments/__generated__/Error.generated';
import { CustomerFragmentDoc } from '../../fragments/__generated__/Customer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomerMutationVariables = Types.Exact<{
  input: Types.CreateCustomerInput;
}>;


export type CreateCustomerMutation = { createCustomer: { errors: Array<{ field: string, messages: Array<string> }>, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null } | null } };

export type CustomerChangeSubscriptionsMutationVariables = Types.Exact<{
  input: Types.CustomerChangeSubscriptionsInput;
}>;


export type CustomerChangeSubscriptionsMutation = { customerChangeSubscriptions: { errors: Array<{ field: string, messages: Array<string> }>, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null } | null } };


export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    errors {
      ...Error
    }
    customer {
      ...CustomerFragment
    }
  }
}
    ${ErrorFragmentDoc}
${CustomerFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CustomerChangeSubscriptionsDocument = gql`
    mutation CustomerChangeSubscriptions($input: CustomerChangeSubscriptionsInput!) {
  customerChangeSubscriptions(input: $input) {
    errors {
      ...Error
    }
    customer {
      ...CustomerFragment
    }
  }
}
    ${ErrorFragmentDoc}
${CustomerFragmentDoc}`;
export type CustomerChangeSubscriptionsMutationFn = Apollo.MutationFunction<CustomerChangeSubscriptionsMutation, CustomerChangeSubscriptionsMutationVariables>;

/**
 * __useCustomerChangeSubscriptions__
 *
 * To run a mutation, you first call `useCustomerChangeSubscriptions` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerChangeSubscriptions` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerChangeSubscriptions, { data, loading, error }] = useCustomerChangeSubscriptions({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerChangeSubscriptions(baseOptions?: Apollo.MutationHookOptions<CustomerChangeSubscriptionsMutation, CustomerChangeSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerChangeSubscriptionsMutation, CustomerChangeSubscriptionsMutationVariables>(CustomerChangeSubscriptionsDocument, options);
      }
export type CustomerChangeSubscriptionsHookResult = ReturnType<typeof useCustomerChangeSubscriptions>;
export type CustomerChangeSubscriptionsMutationResult = Apollo.MutationResult<CustomerChangeSubscriptionsMutation>;
export type CustomerChangeSubscriptionsMutationOptions = Apollo.BaseMutationOptions<CustomerChangeSubscriptionsMutation, CustomerChangeSubscriptionsMutationVariables>;